import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    {
      staticClass: "lpu-services",
      class: _vm.isMobile ? "lpu-services_mobile" : "lpu-services_full",
      attrs: { "data-qa": _vm.dataQA.component, "data-lpu-services": "" },
    },
    [
      _c("InvasiveServiceInfo"),
      _vm._v(" "),
      _c("SearchCombobox", {
        ref: "lpu-services-search",
        staticClass: "mb-2 lpu-services-search",
        attrs: {
          placeholder: "Найти услугу",
          "data-qa": _vm.dataQA.search,
          "initial-data": _vm.serviceClassList,
        },
        on: {
          "search:default": _vm.handleSearchDefault,
          "search:text": _vm.handleSearchText,
          "search:class": _vm.handleSearchClass,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "d-flex justify-space-between align-center":
              !_vm.isMobile && _vm.isEnabledOnlineAppointment !== null,
          },
        },
        [
          _vm.isEnabledOnlineAppointment !== null
            ? _c("LpuServicesOnlineSwitch", {
                class: {
                  "my-2": _vm.isMobile,
                },
                attrs: {
                  "is-enabled-online-app": _vm.isEnabledOnlineAppointment,
                  "data-qa": _vm.dataQA.switchOnlineAppointment,
                },
                on: {
                  "lpu-services-online-switch:change": _vm.handleOnlineSwitch,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isVisibleInitialServiceList,
                  expression: "isVisibleInitialServiceList",
                },
              ],
            },
            [_vm._t("update-date")],
            2
          ),
          _vm._v(" "),
          !_vm.isVisibleInitialServiceList && _vm.serviceList.length
            ? _c("div", [
                _c("div", { staticClass: "d-flex justify-end" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "lpu-services__price-update-text text-caption mt-1",
                      class: _vm.priceUpdateColorPalette,
                      attrs: { "data-qa": _vm.dataQA.serviceDateUpdated },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.priceUpdateTextContent) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isVisibleInitialServiceList,
              expression: "isVisibleInitialServiceList",
            },
          ],
        },
        [
          _vm._t("default", null, null, {
            handleClickServicePrice: _vm.handleClickServicePrice,
          }),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.isVisibleInitialServiceList && _vm.serviceList.length
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "lpu-services__service-list py-4",
                attrs: { "data-qa": _vm.dataQA.serviceList },
              },
              [
                _vm._l(
                  _vm.serviceList,
                  function (serviceClass, serviceClassIndex) {
                    return _c(
                      "div",
                      {
                        key: `service-class-${serviceClassIndex}`,
                        staticClass: "lpu-services__service-group",
                        attrs: { "data-qa": _vm.dataQA.serviceGroup },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-h6 text--text mb-6",
                            attrs: { "data-qa": _vm.dataQA.serviceClassName },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(serviceClass.name) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(
                          serviceClass.sublist,
                          function (service, serviceIndex) {
                            return _c(
                              "div",
                              {
                                key: `service-${serviceIndex}`,
                                staticClass: "lpu-services__service",
                                attrs: { "data-qa": _vm.dataQA.service },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "b-lpu-services__service-wrapper",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "lpu-services__service-item":
                                            !_vm.isMobile,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-inline-block lpu-services__service-name text-body-1",
                                            attrs: {
                                              "data-qa": _vm.dataQA.serviceName,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(service.name) +
                                                "\n\n                "
                                            ),
                                            service.duration
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-body-2 text-secondary--text",
                                                    attrs: {
                                                      "data-qa":
                                                        _vm.dataQA
                                                          .serviceDuration,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.getDurationText(
                                                            service.duration
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isVisibleServiceTypes(service)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "adminka-box pa-0 mt-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          service.service_types.join(
                                                            ", "
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isVisibleWorkplaces(service)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "adminka-box pa-0 mt-1",
                                                  },
                                                  _vm._l(
                                                    service.workplaces,
                                                    function ([
                                                      speciality,
                                                      fios,
                                                    ]) {
                                                      return _c(
                                                        "span",
                                                        { key: speciality },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                speciality
                                                              ) +
                                                              ": " +
                                                              _vm._s(
                                                                fios.join(", ")
                                                              )
                                                          ),
                                                          _c("br"),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex-shrink-0",
                                            class: [
                                              _vm.isMobile
                                                ? "mt-3 w-100"
                                                : "ml-auto",
                                            ],
                                          },
                                          [
                                            _c("LpuServicesPrice", {
                                              staticClass:
                                                "lpu-services__price",
                                              attrs: {
                                                "is-btn":
                                                  _vm.isBtnServicePrice(
                                                    service
                                                  ),
                                                price: service.prices.full,
                                                "has-schedule":
                                                  service.hasSchedule,
                                                "synonym-id":
                                                  service.synonym_id,
                                              },
                                              on: {
                                                "lpu-services-price:click-btn":
                                                  (event) => {
                                                    _vm.handleClickServicePrice(
                                                      {
                                                        id: service.synonym_id,
                                                        allowTreatmentReferral:
                                                          service.allow_treatment_referral,
                                                        requiresPrimaryConsultation:
                                                          service.requires_primary_consultation,
                                                        hasPrimaryConsultationDoctors:
                                                          service.has_primary_consultation_doctors,
                                                        doctorSpecialities:
                                                          service.doctor_specialities,
                                                      },
                                                      event
                                                    )
                                                  },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "service-prices-schedule",
                                      attrs: { "data-qa": _vm.dataQA.schedule },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    )
                  }
                ),
                _vm._v(" "),
                _vm.isActiveButtonShowAll
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-center" },
                      [
                        _c(
                          VBtn,
                          {
                            staticClass: "lpu-services__show-all",
                            attrs: {
                              color: "bg-primary",
                              elevation: "0",
                              "data-qa": _vm.dataQA.buttonShowAll,
                              block: _vm.isMobile,
                            },
                          },
                          [
                            _c("span", { staticClass: "primary--text" }, [
                              _vm._v(
                                "\n            Показать все услуги\n          "
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ])
        : !_vm.isVisibleInitialServiceList
        ? _c(
            "div",
            {
              staticClass: "text-center py-16 my-1",
              attrs: { "data-qa": _vm.dataQA.serviceNotFound },
            },
            [
              _c("img", {
                staticClass: "d-block mb-2 mx-auto",
                attrs: {
                  src: "/static/_v1/pd/pictures/ui-kit/search.svg",
                  width: "150",
                  height: "150",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text--text text-body-1" }, [
                _vm._v("\n      Такой услуги нет в клинике\n    "),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("LpuServicesPagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isVisiblePagination,
            expression: "isVisiblePagination",
          },
        ],
        attrs: {
          "data-qa": _vm.dataQA.pagination,
          "page-count": _vm.paginationData.total,
          "initial-page": _vm.paginationData.current,
        },
        on: { "relocate-page:number": _vm.handleRelocatePage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }